'use client';

import { useModals } from '@/contexts/ModalContext';
import { useTranslations } from 'next-intl';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type Props = {
  onOk: () => void;
};

export const AfterArchivingModal: React.FC<Props> = ({ onOk }) => {
  const modals = useModals();
  const t = useTranslations('modals');

  const onClose = () => {
    onOk();
    modals.close(`after-archiving-modal`);
  };
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('archiving.header')}</DialogTitle>
          <DialogDescription>{t('archiving.text')}</DialogDescription>
        </DialogHeader>

        <Button
          variant='default'
          onClick={onClose}
          className='mt-[24px] h-auto text-m font-medium py-[10px] w-full text-bg-day rounded-[12px]'
        >
          {t('archiving.button')}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
